import { FriendSentListItemProps } from "../type"
import React from "react"
import styled from '~/ui/styled'
import FriendSentListItemCore from "./friend-send-list-item-core"

const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  align-items: center;
`

const FriendSentListItem: React.FC<FriendSentListItemProps> = ({
  friend,
  onItemClick,
}) => {
  return (
    <ItemRow>
      <FriendSentListItemCore
        friend={friend}
        onAccept={() => onItemClick?.(friend, 'APPROVE')}
        onReject={() => onItemClick?.(friend, 'REJECT')}
      />
    </ItemRow>
  )
}

export default FriendSentListItem
